import React, {useMemo} from 'react';
import {useSearchParams} from 'react-router-dom';
import agencyFetchers from '@/api/fetchers/agency';
import {Option} from '@/components/autocomplete/Autocomplete';
import CampaignFilter from '@/components/campaign-filter';
import useBrandId from '@/hooks/use-brand-id';
import useDataQuery from '@/hooks/use-data-query';
import styles from './Stats.module.scss';

function Stats() {
  const brandId = useBrandId();
  const [searchParams, setSearchParams] = useSearchParams();

  const {data: campaigns}: any = useDataQuery({
    queryKey: ['brandStatsFilterableCampaigns', {brandId}],
    queryFn: agencyFetchers.brandStatsFilterableCampaigns,
    meta: {
      brandId,
    },
  });

  const campaignOptions = useMemo(() => {
    const campaignsData = Array.isArray(campaigns) ? campaigns : [];
    return campaignsData.map((campaignOption: any) => ({
      id: campaignOption.id,
      label: campaignOption.name,
    }));
  }, [campaigns]);

  return (
    <div className={styles.container}>
      <CampaignFilter
        testID="stats--campaign-filter"
        options={campaignOptions}
        onChange={(_event: any, selectedOptions: Option[]) => {
          const hasAll = selectedOptions.some((opt) => opt.id === 'all');
          if (hasAll || selectedOptions.length === 0) {
            searchParams.delete('campaign');
          } else {
            const ids = selectedOptions.map((opt) => opt.id).join(',');
            searchParams.set('campaign', ids);
          }
          setSearchParams(searchParams, {replace: true});
        }}
      />
    </div>
  );
}

export default Stats;
